import $ from 'jquery';

export default () => {
  const stickyElements = $(".paragraph--type--image-text-vert");
  const stickyBP = window.matchMedia("(min-width: 1024px)"); // stick only if screen width >= 1024

  $(".bullet-list li:first-of-type .paragraph--type--image-text-vert")
    .addClass("current");

  canStick();
  stickyBP.addListener(canStick);

  $(window).scroll(function() {
    if (stickyBP.matches) {
      let elem = aboveBorder($(".static-content"));

      if (elem) { // if any element at the top
        toggleSticky( // make it visible and hide others
          elem.closest("li").find(".paragraph--type--image-text-vert").first()
        );
      }
    }
  });

  /**
   * @return void
   */
  function canStick() {
    if (stickyBP.matches) {
      make_sticky();
    } else {
      stickyElements.trigger("sticky_kit:detach");
    }
  }

  /**
   * Get the last element with position above border
   *
   * @param jQuery elements
   * @param int border
   *
   * @return jQuery
   */
  function aboveBorder(elements, border = 210) {
    let result = null;

    elements.each(function(key, elem) {
      let top = elem.getBoundingClientRect().top;

      if (top <= border) {
        result = elem;
      }
    });

    return result ? $(result) : null;
  }

  /**
   * Shows elem and hides other sticky elements
   *
   * By default all sticky elements are hidden.
   * Class '.current' makes sticky element visible.
   */
  function toggleSticky(elem) {
    if (!elem.hasClass("current")) {
      $("li .paragraph--type--image-text-vert.current").removeClass("current");
      elem.addClass("current");
    }
  }

  function make_sticky() {
    $(".paragraph--type--image-text-bullet-list .paragraph--type--image-text-vert")
      .stick_in_parent({
        parent: ".paragraph--type--image-text-bullet-list",
        offset_top: 200,
        spacer: false
      });
    $("li .paragraph--type--image-text-vert").stick_in_parent({
      // parent: "li",
      parent: "ul",// ".paragraph--type--custom-bullet-list",
      offset_top: 200,
      spacer: false,
      recalc_every: 10
    });
  }
};
